import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import ListItem_styles from "./ListItem.styles.js";
const ListItem = (t0)=>{
    const $ = c(5);
    const { children } = t0;
    const { classes } = ListItem_styles();
    let t1;
    if ($[0] !== classes.listItem) {
        t1 = classnames(classes.listItem, "aqa_list_item");
        $[0] = classes.listItem;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ jsx("li", {
            className: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
export { ListItem };
